<template>
  <div>
  <ContextTitle :title="$t('fleet.depot')" :enableInfoIcon="false"/>
  <ContextItemAutoComplete
    :eventName="'click'"
    :iconTooltip="$t('fleet.depot')"
    :icon="'fas fa-map-marker-alt'"
    :value="depotAddress | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])"
    :openUpwards="true"
    @autocompleteSave="handleUpdateDepot"
    :list="availableLocations"
  />
  </div>
</template>

<script>
  import { locationService } from '@/_services'
  import { mapActions, mapGetters } from 'vuex'
  import ContextTitle from '@/components/drops/detail/ContextTitle.vue'
  import ContextItem from '@/components/wrld/generic/ContextItem.vue'
  import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete.vue'

  export default {
    name: 'VehicleDepot',
    components: {
      ContextTitle,
      ContextItem,
      ContextItemAutoComplete
    },
    props: {
      depot: { type: Object, default: () => null },
      vehicle: { type: Object, default: () => null }
    },
    data () {
      return {
        availableLocations: [],
      }
    },
    created () {
      if (this.$route.params.organizationID != null) {
        locationService.getListLocations({ organizationID: this.$route.params.organizationID }).then((items) => {
          this.availableLocations = items.map((location) => {
            return {
              ...location,
              text: `${location.name} ${location.type} ${this.$options.filters.AddressObjectToString(location.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}`
            }
          })
        }).catch((error) => {
          console.error(error)
        }).finally(() => {
        })
      }
    },
    methods: {
      ...mapActions({
        setOrganizationVehicleDepot: 'setOrganizationVehicleDepot'
      }),
      handleUpdateDepot (value) {
        this.setOrganizationVehicleDepot({
        item: { ...this.vehicle, depot: value },
        vehicleID: this.vehicle.id,
        depotID: value.id
      })
      },
    },
    computed: {
      depotAddress () {
        if (this.depot != null) {
          return this.depot.address
        } else {
          return this.$i18n.t('fleet.add_depot')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
